import React from "react";
import PageLayout from "./PageLayout";
import Contact from "../sections/Contact";

export default function ContactPage() {
    return (
        <PageLayout testId="contact-page" pageTitle="Əlaqə və qeydiyyat">
            <Contact standalone />
        </PageLayout>
    );
}
